import { layoutActions } from '@Techedge/digitalportal-shared'

export const setModalLoading: DispatchToProps<DispatchModalLoadingProps> = ({
    dispatch,
    loading,
}) => dispatch(layoutActions.setModals({ props: { loading } }))

export const setReloadParentData: DispatchToProps<DispatchFunctionProps> = ({ dispatch }) =>
    dispatch(layoutActions.setModals({ props: { reloadParentData: true } }))

interface DispatchModalLoadingProps extends DispatchFunctionProps {
    loading: boolean
}

export interface DispatchFunctionProps{
    dispatch: (fn: any) => void
}

export type DispatchToProps<T> = (params: T) => void
export type DispatchToPropsComponent<T> = () => DispatchToProps<T>
